module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"alert":{"loadError":"The page you requested could not be loaded. Please check that you are online and try again."}}}')
  delete Component.options._Ctor
}
